module.exports = __webpack_public_path__ + "FJ.png?b7f1d1ed701fdb1a509e3a0119f13aa1";